export default __webpack_public_path__ + "static/media/icon_system_start.271460f6.png";